module.exports = __webpack_public_path__ + "img/motor.7f780b57.svg";